import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../contexts/AppContext";
import { useTheme } from "../../contexts/ThemeContext";
import { getStatusColor } from "../../services/contractService";

export const AdminPanel = () => {
  const navigate = useNavigate();
  const { service } = useApp();
  const { theme } = useTheme();
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("pending");

  useEffect(() => {
    service.getListItems("Contracts").then(d => {
      setContracts(d?.value?.map(i=>({...i.fields,id:i.id}))||[]);
    }).catch(()=>{}).finally(()=>setLoading(false));
  },[]);

  const pending = contracts.filter(c=>["Requested","In Review"].includes(c.Status));
  const expiring = contracts.filter(c=>{
    if(!c.ExpiryDate) return false;
    if(c.Status === "Close Out") return false; // Exclude closed out contracts
    const d=Math.ceil((new Date(c.ExpiryDate)-Date.now())/86400000);
    return d>0&&d<=30;
  });
  const display = {pending, expiring, all:contracts}[tab] || contracts;

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-serif text-3xl font-medium text-light-text dark:text-dark-text mb-1">Admin Panel</h1>
        <p className="text-light-text-secondary dark:text-dark-text-secondary m-0">Manage contracts, approvals, templates and users.</p>
        <div className="h-0.5 bg-gradient-to-r from-accent to-transparent mt-2" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        {[
          {icon:"X",label:"User Mgmt",onClick:()=>navigate("/admin/users"),color:"#0078d4"},
          {icon:"Y",label:"All Contracts",onClick:()=>navigate("/contracts"),color:"#107c10"},
          {icon:"Z",label:"Templates",onClick:()=>navigate("/templates"),color:"#8764b8"},
          {icon:"W",label:"Files",onClick:()=>navigate("/files"),color:"#c9a84c"},
        ].map((a,i)=>(
          <button key={i} onClick={a.onClick} style={{color: a.color}} className="bg-light-bg-secondary dark:bg-dark-bg-secondary border border-light-border dark:border-dark-border rounded-lg p-4 cursor-pointer text-left font-sans font-semibold text-base hover:opacity-80 transition-opacity">
            {a.label}
          </button>
        ))}
      </div>
      <div className="bg-light-bg-secondary dark:bg-dark-bg-secondary border border-light-border dark:border-dark-border rounded-lg overflow-hidden">
        <div className="flex border-b border-light-border dark:border-dark-border px-1">
          {[{id:"pending",label:"Pending Action",n:pending.length},{id:"expiring",label:"Expiring Soon",n:expiring.length},{id:"all",label:"All",n:contracts.length}].map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} className={`px-4 py-3 bg-none border-none cursor-pointer font-sans text-base transition-colors ${tab===t.id ? "text-accent border-b-2 border-accent" : "text-light-text-secondary dark:text-dark-text-secondary border-b-2 border-transparent hover:text-light-text dark:hover:text-dark-text"}`}>
              {t.label} ({t.n})
            </button>
          ))}
        </div>
        {loading ? <div className="p-10 text-center text-light-text-secondary dark:text-dark-text-secondary">Loading...</div> : (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-base">
              <thead><tr className="bg-light-bg-tertiary dark:bg-dark-bg-tertiary">
                {["Ref","Title","Entity","Vendor","Status","Requested","Cycle"].map(h=>(
                  <th key={h} className="px-4 py-2.5 text-left text-base font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase tracking-wider border-b border-light-border dark:border-dark-border">{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {display.length===0 ? <tr><td colSpan={7} className="p-10 text-center text-light-text-secondary dark:text-dark-text-secondary">None.</td></tr>
                : display.map((c,i)=>(
                  <tr key={i} onClick={()=>navigate("/contracts/"+c.id)} className="cursor-pointer border-b border-light-border dark:border-dark-border hover:bg-light-bg-tertiary dark:hover:bg-dark-bg-tertiary transition-colors">
                    <td className="px-4 py-2.5 font-mono text-base text-accent">{c.RefNo||"--"}</td>
                    <td className="px-4 py-2.5 max-w-48"><div className="overflow-hidden text-ellipsis whitespace-nowrap text-light-text dark:text-dark-text">{c.Title||"Untitled"}</div></td>
                    <td className="px-4 py-2.5 text-base text-light-text-secondary dark:text-dark-text-secondary">{c.Entity}</td>
                    <td className="px-4 py-2.5 text-light-text dark:text-dark-text">{c.VendorName}</td>
                    <td className="px-4 py-2.5"><span style={{backgroundColor: getStatusColor(c.Status)+"20", color: getStatusColor(c.Status)}} className="px-2 py-0.5 rounded-full text-base font-medium">{c.Status}</span></td>
                    <td className="px-4 py-2.5 text-base text-light-text-secondary dark:text-dark-text-secondary">{c.RequestDate?new Date(c.RequestDate).toLocaleDateString():""}</td>
                    <td className={`px-4 py-2.5 font-mono text-base ${c.CycleDays>30 ? "text-red-600" : "text-green-700"}`}>{c.CycleDays||"--"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
